module.exports = __webpack_public_path__ + "img/bg-sect-8.e69f7053.png";